import * as DataStoreClassifications from './classifications/DataStoreClassifications.selectors';
import * as DataStoreRequestActions from './requestActions/DataStoreRequestActions.selectors';

export const classifications = DataStoreClassifications;
export const requestActions = DataStoreRequestActions;
